const component = "consumption-overview-sites";

export const consumptionOverviewSites = {
  component,
  searchSiteInput: `${component}/search-site-input`,
  sitesDataTable: {
    table: `${component}/table`,
    siteName: `${component}/site-name`,
  },
};
